import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSideMenuStore = defineStore('sideMenu', () => {
  const isCollapsed = ref(true);

  const setCollapsed = (collapsed: boolean) => {
    isCollapsed.value = collapsed;
  };

  const toggle = () => {
    isCollapsed.value = !isCollapsed.value;
  };

  return {
    isCollapsed,
    setCollapsed,
    toggle,
  };
});
